import React, { useEffect, useRef } from 'react';
import Hls from 'hls.js';

const HLSPlayer = ({ src, autoPlay = false, controls = true, width = '100%', height = 'auto' }) => {
  const videoRef = useRef(null);
  const hlsRef = useRef(null);

  useEffect(() => {
    const video = videoRef.current;
    
    // 소스가 없는 경우 처리하지 않음
    if (!src) return;
    
    // 기존 HLS 인스턴스가 있다면 정리
    if (hlsRef.current) {
      hlsRef.current.destroy();
    }
    
    // HLS.js 지원 여부 확인
    if (Hls.isSupported()) {
      const hls = new Hls({
        enableWorker: true,
        lowLatencyMode: true,
        backBufferLength: 90
      });
      
      hls.loadSource(src);
      hls.attachMedia(video);
      
      hls.on(Hls.Events.MANIFEST_PARSED, () => {
        if (autoPlay) {
          video.play().catch(e => console.log('Auto play failed:', e));
        }
      });
      
      hls.on(Hls.Events.ERROR, (event, data) => {
        if (data.fatal) {
          switch (data.type) {
            case Hls.ErrorTypes.NETWORK_ERROR:
              console.log('네트워크 오류, 복구 시도 중...');
              hls.startLoad();
              break;
            case Hls.ErrorTypes.MEDIA_ERROR:
              console.log('미디어 오류, 복구 시도 중...');
              hls.recoverMediaError();
              break;
            default:
              console.error('치명적인 오류, 복구 불가:', data);
              hls.destroy();
              break;
          }
        }
      });
      
      hlsRef.current = hls;
    } 
    // 기본 비디오 태그에서 HLS를 지원하는 경우 (iOS Safari 등)
    else if (video.canPlayType('application/vnd.apple.mpegurl')) {
      video.src = src;
      
      if (autoPlay) {
        video.play().catch(e => console.log('Auto play failed:', e));
      }
    }
    
    return () => {
      if (hlsRef.current) {
        hlsRef.current.destroy();
      }
    };
  }, [src, autoPlay]);

  return (
    <video
      ref={videoRef}
      controls={controls}
      width={width}
      height={height}
      style={{ maxWidth: '100%' }}
    />
  );
};

export default HLSPlayer;